import dcmjs from 'dcmjs';
import dicomImageLoader from '@cornerstonejs/dicom-image-loader';
import FileLoader from './fileLoader';

const PIXEL_DATA_TAG = '7FE00010';

// microscopy reads its frames from the stored dataset
const needsPixelData = dict => dict['00080060']?.Value?.[0] === 'SM';

const DICOMFileLoader = new (class extends FileLoader {
  fileType = 'application/dicom';
  loadFile(file, imageId) {
    return dicomImageLoader.wadouri.loadFileRequest(imageId);
  }

  getDataset(image, imageId) {
    // pixels come from the file when a slice is shown; parsing them here
    // kept a second copy of every image in memory
    let dicomData = dcmjs.data.DicomMessage.readFile(image, {
      untilTag: PIXEL_DATA_TAG,
      includeUntilTagValue: false,
    });
    if (needsPixelData(dicomData.dict)) {
      dicomData = dcmjs.data.DicomMessage.readFile(image);
    }

    const dataset = dcmjs.data.DicomMetaDictionary.naturalizeDataset(dicomData.dict);

    dataset.url = imageId;

    dataset._meta = dcmjs.data.DicomMetaDictionary.namifyDataset(dicomData.meta);

    dataset.AvailableTransferSyntaxUID =
      dataset.AvailableTransferSyntaxUID || dataset._meta.TransferSyntaxUID?.Value?.[0];

    return dataset;
  }
})();

export default DICOMFileLoader;
